"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processFormat = void 0;
const react_1 = require("react");
const processFormat = (str, params) => {
    const found = [];
    const rxp = /{([^}]+)}/g;
    let curMatch = null;
    let lastLength = 0;
    while ((curMatch = rxp.exec(str))) {
        if (curMatch.index !== 0 && found.length === 0) {
            found.push({
                type: 'text',
                text: str.substring(0, curMatch.index),
            });
        }
        else if (lastLength !== str.length && lastLength !== curMatch.index) {
            found.push({
                type: 'text',
                text: str.substring(lastLength, curMatch.index),
            });
        }
        found.push({
            type: 'format',
            text: curMatch[1],
        });
        lastLength = curMatch.index + curMatch[0].length;
    }
    if (lastLength !== str.length) {
        found.push({
            type: 'text',
            text: str.substring(lastLength),
        });
    }
    return found.map((item, index) => {
        if (item.type === 'text') {
            return item.text;
        }
        const element = params[item.text] || item.text;
        if ((0, react_1.isValidElement)(element)) {
            return (0, react_1.cloneElement)(element, { key: `format-${index}` });
        }
        return element;
    });
};
exports.processFormat = processFormat;
